import React , {useEffect, useState} from 'react'
import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Row,
    Col,
    Button,
    Label,
    Form,
    FormGroup,
    FormFeedback,
    Input,
    FormText,
    Card,
    CardBody,
    CardHeader,
    Collapse
} from "reactstrap";
import PropTypes from "prop-types";



export default function Accordion(props) {
    
    const toggleSection =( index , e) => () => {
        props.toggleAccordion && props.toggleAccordion((index === props.open ? undefined : index))
    };

    return (
        <div className="accordion w-100">
            {
            React.Children.map(props.children, (child, index) => {
                if (child.type !== AccordionItem) 
                    return null;
                
                return React.cloneElement(child, {
                    isOpen:( props.open === index),
                    onClick: toggleSection(index )
                });
            })
        } </div>
    );
}

Accordion.propTypes = {
    open: PropTypes.number,
    expand:PropTypes.bool
};

const AccordionItem = ({children, isOpen, onClick}) => (

    <Card> {
        React.Children.map(children, child => {
            if (child.type === AccordionHeader) {
                return React.cloneElement(child, {onClick , isOpen});
            }

            if (child.type === AccordionBody) {
                return React.cloneElement(child, {isOpen});
            }

            return null;
        })
    } </Card>
);

const AccordionHeader = ({children, onClick , isOpen}) => (
    <CardHeader>
        <h5 className="mb-0">
            <Button color="link"
                onClick={onClick}>
                {children} 
                {/* <i class={`fa fa-angle-${isOpen ? 'down':"up"}`} aria-hidden="true"></i> */}
                <i class={isOpen ? `fa fa-angle-down` : `fa fa-angle-up`} aria-hidden="true"></i>
                </Button>
        </h5>
         
    </CardHeader>
);

const AccordionBody = ({children, isOpen}) => (
    <Collapse isOpen={isOpen}>
        <CardBody>{children}</CardBody>
    </Collapse>
);

Accordion.Item = AccordionItem;
Accordion.Header = AccordionHeader;
Accordion.Body = AccordionBody;
